// removed by extract-text-webpack-plugin
module.exports = {"gateway-logo":"gateway-logo__2ncVj","banner-img":"banner-img__36Mi-"};


//////////////////
// WEBPACK FOOTER
// ./components/SmallcaseBanner/SmallcaseBanner.css
// module id = OU9m
// module chunks = 14